<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
		<div class="o-form -two-columns">
			<div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>

            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Liste de métiers</h1>
                        <Listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted = $event"
                            :showDeleted="showDeleted"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else-if="form.id && !form.deleted_at">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h1 class="o-form__title">Métier</h1> -->
                            <input
                                type="hidden"
                                name="id"
                                v-model="form.id"
                                v-if="form.id"
                            />
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder="Nom du métier"
                                    label="Nom du métier"
                                    required=true
                                    error-message="Ce champ est requis"
                                    v-model="form.name"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="shortname"
                                    placeholder="Ex. CAL"
                                    label="Abréviation"
                                    required=true
                                    error-message="Ce champ est requis"
                                    v-model="form.shortname"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>

                            <div class="o-form__item">
                                <q-item tag="label">
                                    <q-item-section side style="justify-content: start">
                                        <q-checkbox size="xs" dense v-model="form.isForeman" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label style="font-size: 12px; font-weight: 600;">Rôle de contremaître</q-item-label>
                                        <q-item-label caption>L'utilisateur affecté à ce métier remplira le rôle de contremaître</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </div>

                            <!-- <div class="o-form__item -button -multiple">
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="form.id">Sauvegarder</button>
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="!form.id">Ajouter</button>
                            </div> -->
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { PROFESSIONS } from '@/graphql/tag/queries'
    import { UPSERTPROFESSION, DELETETAG, RESTORETAG } from '@/graphql/tag/mutations'
    import { removeNULL } from '@/js/utilities'

    export default {
        name: 'professions',
        apollo: {
            professions: {
                query: PROFESSIONS,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        trashed: this.trashed,
                        first: this.perPage,
                    }
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(professions) {
                    this.listbox.listItems = Object.assign([], professions.professions)
                    return professions;
                }
            },
        },
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: 'Copier',
                    searchable: 'Rechercher / filtrer'
                },
                form: {},
                newItem: {
                    id: null,
                    name: null,
                    primary_phone: null,
                    secondary_phone: null,
                    fax: null,
                    street: null,
                    town: null,
                    state: null,
                    country: null,
                    zipcode: null,
                    website: null,
                },
                showDeleted: false,
                perPage: 50,
            }
        },
        mounted: async function(){
            this.setNewItem()
        },
        computed: {
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
        },
        methods: {
            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form=Object.assign({}, item);
            },
            setNewItem(){
                this.listbox.selectedItem=Object.assign({}, this.newItem);
                this.form = Object.assign({}, this.newItem);

                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETETAG,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.professions) this.$apollo.queries.professions.refetch()
                        this.setSelected(null);
                    }

                })

            },
            saveItem(form) {
                form=removeNULL(form);
                this.$apollo.mutate({
                    mutation: UPSERTPROFESSION,
                    variables: { ...form },
                    update: (store, {data: {upsertProfession}}) => {
                        if (this.$apollo.queries.professions) this.$apollo.queries.professions.refetch()
                        this.setSelected(upsertProfession)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Profession : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORETAG,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { tag } }) => {
                        if(!form.id){
                            const data = store.readQuery({ query: PROFESSIONS })
                            data.professions.push(tag);
                            store.writeQuery({
                                query: PROFESSIONS,
                                data,
                            })
                        }
                        this.setSelected(tag)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Ressource : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
